import { useEffect } from "react";

// Custom hook that listens for an out of target event

const useOutsideAlert = (ref, handleClick, ignoreId) => {
  useEffect(() => {
    const handleClickOutside = event => {
      // A click can remove its own target from the DOM before this handler
      // runs (e.g. clicking a react-select indicator that synchronously
      // unmounts on click). A detached node is never "contained" by
      // anything, so without this guard such clicks are wrongly treated as
      // outside clicks. See: EscalateRiskModal dropdown arrow/clear icons.
      if (!document.body.contains(event.target)) return;

      const ignoreElement = ignoreId ? document.getElementById(ignoreId) : null;
      if (
        ref?.current &&
        !ref.current?.contains(event.target) &&
        !ignoreElement?.contains?.(event.target)
      ) {
        handleClick?.();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [ref, ignoreId, handleClick]);
};

export default useOutsideAlert;
